import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { ModalComponent } from '../core/modal/modal.component';
import { NotificationService } from '../services/notification.service';
import { ToastrService } from 'ngx-toastr';

@Component({
    selector: 'notification-setup-modal',
    templateUrl: './notification-setup-modal.component.html',
    styleUrls: ['./notification-setup-modal.component.scss'],
    standalone: false
})
export class NotificationSetupModalComponent implements OnInit {
  form: FormGroup;

  @Output() close: EventEmitter<boolean> = new EventEmitter();
    
  @ViewChild(ModalComponent) modal: ModalComponent;

  constructor(private fb: FormBuilder, private notificationService: NotificationService, private toastrService: ToastrService) {
    this.form = this.fb.group({
      enabled: new FormControl(false),
      subscriptionNotifications: this.fb.group({
        ninetyDays: new FormControl(false),
        thirtyDays: new FormControl(false),
        zeroDays: new FormControl(false),
      }),
      allowanceNotifications: this.fb.group({
        ninetyPercent: new FormControl(false),
        hundredPercent: new FormControl(false),
      })
    });
  }

  ngOnInit(): void {
    this.notificationService.get().subscribe(userData => {
      this.form.get("enabled").setValue(userData.enabled);

      this.form.get("subscriptionNotifications")
        .get("ninetyDays")
        .setValue(userData.subscriptionNotifications.ninetyDays);
      this.form.get("subscriptionNotifications")
        .get("thirtyDays")
        .setValue(userData.subscriptionNotifications.thirtyDays);
      this.form.get("subscriptionNotifications")
        .get("zeroDays")
        .setValue(userData.subscriptionNotifications.zeroDays);
      
      this.form.get("allowanceNotifications")
        .get("ninetyPercent")
        .setValue(userData.allowanceNotifications.ninetyPercent);
      this.form.get("allowanceNotifications")
        .get("hundredPercent")
        .setValue(userData.allowanceNotifications.hundredPercent);
    });
  }

  modalCleanup(){
    this.close.emit();
  }

  closeModal(){
    this.modal.closeModal();
    this.close.emit();
  }

  submitForm(){
    const request = this.form.getRawValue();
    this.notificationService.post(request).subscribe(x => {
      this.toastrService.success("Successfully updated notification settings.");
    });
  }
}
